exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".c-list-filter{display:block;max-width:100%;margin:0}", ""]);

// exports
